module.exports = __webpack_public_path__ + "static/media/Covid-19.d7265326.png";